import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface BoxProps {
  $tone?: 'success' | 'positive' | 'accent';
  $gutter?: 'large';
  $relative?: boolean;
  $fillHeight?: boolean;
}

export const Box = styled.div.withConfig({ componentId: 'sc-dzcw32-0' })<BoxProps>`
    border: 1px solid var(--c-border-main);
    border-radius: ${(props) => props.theme.size.borderRadius};

    ${({ $tone }) =>
      $tone === 'success' &&
      css`
            border-color: var(--c-semantic-success-500);
        `}

    ${({ $tone }) =>
      $tone === 'positive' &&
      css`
            border: none;
            background-color: var(--c-positive-bg);
        `}

    ${({ $tone }) =>
      $tone === 'accent' &&
      css`
            border-color: var(--c-accent-tertiary-border);
        `}

    ${({ $gutter }) =>
      $gutter === 'large'
        ? css`
                  padding: ${size(3)};
              `
        : css`
                  padding: ${size(2)};
              `}

    ${({ $relative }) =>
      $relative &&
      css`
            position: relative;
        `}

    ${({ $fillHeight }) =>
      $fillHeight &&
      css`
            height: 100%;
        `}
`;
